/* eslint-disable import/prefer-default-export */
export const HeaderComponentStyles = () => ({
    grow: {
        color: 'var(--gheader-text-color)',
        top: 0,
        width: '100vw',
        display: 'flex',
        justifyContent: 'space-between',
        backgroundColor: 'var(--gheader-bg-color)',
        boxShadow: '1px 2px 1px rgba(0, 0, 0, 0.15)',
        marginBottom: '2px',
        height: '72px',
        zIndex: 1000,
        '& .MuiTypography-root': {
            display: 'flex',
            alignItems: 'center',
        },
        '& .MuiLink-underlineHover:hover': {
            textDecoration: 'none',
        },
        '& .MuiToolbar-root': {
            minHeight: 44,
            display: 'flex',
            justifyContent: 'space-between',
        },
        '& .MuiIconButton-root:hover': {
            backgroundColor: 'inherit',
            cursor: 'pointer',
        },
        '& .menuIcon': {
            color: 'var(--turquoise)',
        },
        '& .MuiOutlinedInput-notchedOutline': {
            border: 'none',
        },
        '& .icon-Upload': {
            color: 'var(--gheader-icon-color)',
            cursor: 'pointer',
            margin: '0px 20px',
        },
        '& .icon-Help-18': {
            color: 'var(--gheader-icon-color)',
            cursor: 'pointer',
            margin: '0px 10px',
        },
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: '99',
        '& .MuiInputBase-root': {
            color: 'var(--gheader-text-color)',
            paddingRight: 5,
        },
        '& .MuiSelect-icon': {
            color: 'var(--gheader-icon-color)',
        },
    },
    form: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: '99',
        '& .MuiInputBase-root': {
            color: 'var(--gheader-text-color)',
            paddingRight: 5,
        },
        '& .MuiSelect-icon': {
            color: 'var(--gheader-icon-color)',
        },
    },
    supportMenu: {
        cursor: 'pointer',
        userSelect: 'none',
        borderRadius: '5px',
        padding: '2px 15px 4px 15px',
        marginRight: '15px',
        fontSize: '15px',
        '&:hover': {
            textDecoration: 'underline',
        },
    },
    menu: {
        '& .MuiMenuItem-root:hover': {
            textDecoration: 'underline',
        },
    },
});
